import { Box, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import Image from "src/components/Image";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";
import { base64ToFile } from "src/utils/file";
import { entitiesLogoUrl } from "src/utils/formatUrl";

import Context from "../../context";

// ----------------------------------------------------------------------

export default function ImportingMessage() {
	const { theme, state, product } = useContext(Context);

	const isMobile = useResponsive("down", "sm");
	const { translate } = useLocales();

	return (
		<Stack sx={{ alignItems: "center" }}>
			<Stack
				flexDirection={"row"}
				alignItems={"center"}
				justifyContent={"space-between"}
				sx={{ mt: { xs: 2, sm: 10 } }}
			>
				<Image src={entitiesLogoUrl(state.entity?.id ?? "")} sx={{ width: { xs: 50, sm: 140 } }} />
				<Iconify
					icon='eos-icons:three-dots-loading'
					sx={{ px: 4, width: isMobile ? 150 : 300, height: isMobile ? 100 : 120 }}
					color={theme?.colors.primary}
				/>

				<Image
					src={URL.createObjectURL(base64ToFile(theme?.logo!, "logo"))}
					sx={{ width: { xs: 40, sm: 130 } }}
				/>
			</Stack>

			<Box sx={{ maxWidth: 700, margin: "auto", textAlign: "center", mt: { xs: 1, sm: 8 } }}>
				<Typography paragraph variant={isMobile ? "h4" : "h3"} color={theme?.colors.primaryText}>
					{translate("transfers.importing")}
				</Typography>
				<Typography
					variant={isMobile ? "body2" : "body1"}
					color={theme?.colors.secondaryText}
					mt={4}
				>
					{translate(
						product !== "ASSETS_TRANSFER" ? "importing.description" : "importing.description_2"
					)}
				</Typography>
			</Box>
		</Stack>
	);
}
